<template>
    <EditServiceReport2></EditServiceReport2>
</template>
<script>
    import EditServiceReport2 from '@/components/EditServiceReport2.vue'
    export default {
        name: 'employee-sign',
        components: {
            EditServiceReport2
        }
    }
</script>